<template>
    <el-dialog class="editor-dialog" append-to-body :visible.sync="visible" :show-close="false"  width='400px' top='10vh'>
      <el-upload
        class="upload-demo"
        drag
        :accept='accept'
        :action="$http.defaults.baseURL + '/oss/upload/file'"
        :headers="getAuthHeaders()"
        :show-file-list="false"
        :on-success="afterUpload"
        ref="upload"
      >
        <em class="el-icon-upload"></em>
        <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
      </el-upload>
    </el-dialog>
</template>
<script>
export default {
  data(){
    return{
      visible:false,
      row:null,
      accept:'*'
    }
  },
  methods: {
    afterUpload(res) {
      this.callback(res,this.row)
      this.visible=false
    }
  }
};
</script>
<style scoped>
.editor-dialog>>>.el-dialog__header{
  display:none;
}
</style>
